import {soundOffSvg as Icon__small__soundOffSvg} from '../Icon__small/Icon__small--soundOff.js';

export var soundOff = {
  name: 'soundOff',
  category: 'icon',
  colorable: true,
  svg: Icon__small__soundOffSvg,
};
